import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';
import React from 'react';

export const SvgArrowUpward = () => (
  <ArrowUpIcon label="" testId="ads-refreshed-icon" />
);
